export const defaultSuccessRateInfo = {
  status: '-',
  pingPongCount: null,
  successRate: null,
  totalEvents: null,
  p95Latency: null,
  threshold: null,
  series: [],
};
